import React, { createContext, useContext, useState } from 'react';
import defaultConfig from './defaultConfig';

export interface AppLocale {
  code: string;
  name: string;
  icon: string;
}

interface LocaleContextValue {
  locale: AppLocale;
  rtlLocale: string[];
}

interface LocaleActionsContextValue {
  updateLocale: React.Dispatch<React.SetStateAction<AppLocale>>;
}

const LocaleContext = createContext<LocaleContextValue | undefined>(undefined);
const LocaleActionsContext = createContext<
  LocaleActionsContextValue | undefined
>(undefined);

export const useLocaleContext = (): LocaleContextValue => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error(
      'useLocaleContext must be used inside LocaleContextProvider',
    );
  }
  return context;
};

export const useLocaleActionsContext = (): LocaleActionsContextValue => {
  const context = useContext(LocaleActionsContext);
  if (!context) {
    throw new Error(
      'useLocaleActionsContext must be used inside LocaleContextProvider',
    );
  }
  return context;
};

const LocaleContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [locale, updateLocale] = useState(defaultConfig.locale);

  return (
    <LocaleContext.Provider
      value={{
        locale,
        rtlLocale: defaultConfig.rtlLocale,
      }}
    >
      <LocaleActionsContext.Provider
        value={{
          updateLocale,
        }}
      >
        {children}
      </LocaleActionsContext.Provider>
    </LocaleContext.Provider>
  );
};

export default LocaleContextProvider;
